import { FunctionComponent, useCallback } from 'react'

import styled, { css, useTheme } from 'styled-components'

import config from '@config'
import translate from '@i18n'
import useTracking, { TrackingFnType } from '@hooks/useTracking'
import PrimaryCTALink from '@components/Buttons/PrimaryCTABlink'
import SvgIcon from '@components/SvgIcon'
import ImageWrapper from '@components/UserProfilePage/LeserreporterEntryPoint/ImageWrapper'

const {
  leserreporter: { leserreporterPageUrl },
} = config

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing16 },
    },
  }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    padding: ${spacing16};

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
  `}
`

const Title = styled.h2`
  ${({
    theme: {
      typography: {
        bodycopy: {
          small1: { bundledCSS: small1BodyCopyCSS },
        },
      },
      colors: { staticWhite },
    },
  }) => css`
    color: ${staticWhite};
    ${small1BodyCopyCSS};
    margin: 0;
  `}
`

const Text = styled.span`
  ${({
    theme: {
      typography: {
        bodycopy: {
          small2: { bundledCSS: small2BodyCopyCSS },
        },
      },
      colors: { staticWhite },
    },
  }) => css`
    color: ${staticWhite};
    ${small2BodyCopyCSS};
  `}
`

const TextWrapper = styled.div``
const StyledPrimaryCTALink = styled(PrimaryCTALink)`
  width: 100%;
`

const LeserreporterEntryPoint: FunctionComponent = () => {
  const theme = useTheme()

  const trackingOnClick = useCallback<TrackingFnType>(
    () => ({
      event: 'leserreporter_lp_click',
      button_label: 'Leserreporter',
    }),
    [],
  )

  const handleTrack = useTracking(trackingOnClick)

  const handleClick = useCallback(() => {
    handleTrack()
  }, [handleTrack])

  return (
    <ImageWrapper>
      <StyledWrapper>
        <TextWrapper>
          <Title>{translate('userProfilePage.leserreporterEntry.title')}</Title>
          <Text>{translate('userProfilePage.leserreporterEntry.text')}</Text>
        </TextWrapper>
        <StyledPrimaryCTALink
          onClick={handleClick}
          href={leserreporterPageUrl}
          colorVariant="white"
          size="large"
        >
          <SvgIcon
            iconName="camera"
            size={24}
            color={theme.colors.staticBlack}
          />
          {translate('userProfilePage.leserreporterEntry.buttonText')}
        </StyledPrimaryCTALink>
      </StyledWrapper>
    </ImageWrapper>
  )
}

export default LeserreporterEntryPoint
